import axios from '../utils/axios';

export default function fetchTagMailerCreators(adminId) {
    return (
        axios.get(`/admin/${adminId}/tag-mailers/creators`)
    )
};
